export default "__VITE_ASSET__CR2nIP$z__"